import { useEffect } from 'react';
import { SEO_CONFIG, SITE_URL } from '../config/seo';

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSEO({
  title,
  description,
  keywords,
  path = '',
  image,
  noIndex = false,
  type = 'website',
}) {
  useEffect(() => {
    const siteUrl = SITE_URL || window.location.origin;
    const fullTitle =
      !title || title === SEO_CONFIG.siteName
        ? SEO_CONFIG.siteName
        : `${title} | ${SEO_CONFIG.siteName}`;
    const desc = description || SEO_CONFIG.defaultDescription;
    const pagePath = path || window.location.pathname;
    const url = `${siteUrl.replace(/\/$/, '')}${pagePath}`;
    const ogImage = image
      ? `${siteUrl}${image}`
      : `${siteUrl}${SEO_CONFIG.defaultImage}`;

    document.title = fullTitle;
    document.documentElement.lang = SEO_CONFIG.language;

    upsertMeta('name', 'description', desc);
    upsertMeta('name', 'keywords', keywords || SEO_CONFIG.defaultKeywords);
    upsertMeta('name', 'author', SEO_CONFIG.siteName);
    upsertMeta('name', 'robots', noIndex ? 'noindex,nofollow' : 'index,follow');
    upsertMeta('name', 'googlebot', noIndex ? 'noindex,nofollow' : 'index,follow');

    upsertMeta('name', 'geo.region', 'TN-11');
    upsertMeta('name', 'geo.placename', 'Tunis');
    upsertMeta(
      'name',
      'geo.position',
      `${SEO_CONFIG.business.geo.latitude};${SEO_CONFIG.business.geo.longitude}`,
    );
    upsertMeta(
      'name',
      'ICBM',
      `${SEO_CONFIG.business.geo.latitude}, ${SEO_CONFIG.business.geo.longitude}`,
    );

    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:locale', SEO_CONFIG.locale);
    upsertMeta('property', 'og:site_name', SEO_CONFIG.siteName);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertMeta('name', 'twitter:image', ogImage);
    if (SEO_CONFIG.twitterHandle) {
      upsertMeta('name', 'twitter:site', SEO_CONFIG.twitterHandle);
    }

    upsertLink('canonical', url);
  }, [title, description, keywords, path, image, noIndex, type]);
}
